import {JournalActivityUtils} from "./JournalActivityUtils";
import {WatchedActivity} from "./types";
import {DateTime} from "mu-js-utils/lib/DateTime";

export class Notifier {

    private watchedActivity: WatchedActivity | null = null;

    private mutedWatchedActivity: number[] = [];

    async updateWatch(journalActivity: WatchedActivity|null|undefined = undefined) {
        if (journalActivity === undefined) journalActivity = this.watchedActivity;
        this.watchedActivity = journalActivity;
        if (!journalActivity) {
            (await this.getWatchNotify())?.close();
        }
        if (journalActivity) {
            if (!this.mutedWatchedActivity.includes(journalActivity.id)) {
                await this.showNotify(
                    'Stopuji ' + journalActivity.name + ' '
                    + JournalActivityUtils.formatCurrentDuration(journalActivity),
                    {
                        requireInteraction: true,
                        tag: 'watchedActivity',
                        renotify: true,
                    }
                );
                (await this.getWatchNotify())!.addEventListener('close', (ev) => {
                    console.log(ev);
                    // this.mutedWatchedActivity.push(journalActivity.journalActivityId);
                })
            }
        }
    }

    public async showNotify(message: string, opts: NotificationOptions&{data?:any|NotifyClickAction} = {}): Promise<Notification|null>
    {
        await (await this.getRegistration()).showNotification(message, {
            ...opts,
        });

        return null;

        /*{
                body: "Buzz! Buzz!",
                icon: "../images/touch/chrome-touch-icon-192x192.png",
                vibrate: [200, 100, 200, 100, 200, 100, 200],
                tag: "vibration-sample",
            }); */
    }

    private async getRegistration() {
        return typeof self !== 'undefined'
            ? self.registration
            : await navigator.serviceWorker.ready;
    }

    private async getWatchNotify(tag: string = 'watchedActivity'): Promise<Notification|null> {
        const notifications = await (await this.getRegistration()).getNotifications({ tag: tag });
        if (notifications.length > 0) return notifications[0];
        return null;
    }

    proccesPush(data: any&{type:string}) {
        console.log("Push data", data);
        switch (data.type) {
            case 'trainerNote':
                this.showNotify(
                    'Trenér okomentoval tvůj den',
                    {
                        data: {
                            action: 'openDay',
                            actionData: {
                                day: data.day
                            }
                        }
                    }
                );
                break;
            case 'planRemind':
                /* {type: 'planRemind', day: '2025-06-02T08:00:00+00:00', dtActivity: '2025-06-02T08:00:00+00:00',
                activityName: 'Aktivita', activityVariantName: 'Kardio'} */
                this.showNotify(
                    `${DateTime.format(data.dtActivity, 'H:i')} ${data.activityName}${data.activityVariantName ? ' / ' + data.activityVariantName : ''}`,
                    {
                        data: {
                            action: 'openDay',
                            actionData: {
                                day: data.day
                            }
                        }
                    }
                );
                break;
        }
    }

    notifyClick(data: NotifyData): NotifyClickResponse|Promise<NotifyClickResponse> {
        switch (data.action) {
            case "openDay":
                return {
                    openUrl: '/app/day/' + data.actionData.day,
                    message: 'reloadDay',
                };
        }
    }

    /* private async activateOrOpenUrl(url: string, clients, message: any|null = null) {
        const clientList = await clients.matchAll({ type: 'window', includeUncontrolled: true });
        for (const client of clientList) {
            if (client.url === url) {
                await client.focus();
                if (message) client.postMessage(message);

                return client;
            }
        }
        if (clients.openWindow) {
            const client = await clients.openWindow(url);
            if (message) client.postMessage(message);

            return client;
        }
    } */
}

export const notifier = new Notifier();

export type NotifyClickAction = "openDay"

export type NotifyData = {action:NotifyClickAction,actionData:any};

export type NotifyClickResponse = {
    openUrl?: string|null,
    message?: any|null,
}